import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const Counter = ({ to, decimals = 0, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2.2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref}>
      {val.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}
      {suffix}
    </span>
  );
};

const STATS = [
  { value: 30000, suffix: "+", label: "Orders Successfully Processed & Managed", testId: "stat-count-orders-30k" },
  { value: 5500, suffix: "+", label: "Designs Delivered", testId: "stat-count-designs-5.5k" },
  { value: 24, suffix: "/5", label: "Dedicated Coverage In Your Hours", testId: "stat-count-coverage" },
  { value: 4, suffix: "", label: "Global Regions Served Live", testId: "stat-count-global-regions" },
];

const Stats = () => (
  <section className="relative overflow-hidden bg-[#2E3192] py-20 sm:py-24">
    <div
      className="pointer-events-none absolute inset-0"
      style={{ background: "radial-gradient(800px circle at 50% 0%, rgba(109,200,240,0.28), transparent 70%)" }}
    />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex items-center gap-4" data-testid="stats-section-tag">
        <span className="font-mono2 text-xs tracking-[0.3em] text-[#6DC8F0]">03</span>
        <span className="h-px w-12 bg-[#6DC8F0]/60" />
        <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-blue-100">By The Numbers</span>
      </div>
      <div className="mt-12 grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div data-testid={s.testId} className="text-center lg:text-left">
              <p className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                <Counter to={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
              </p>
              <p className="mt-3 font-mono2 text-[10px] uppercase tracking-[0.22em] leading-relaxed text-blue-200 sm:text-[11px]">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
